import { getList } from './list'
import { getDetails, getSpecificDetail } from './details'
import {
  updateStatus,
  updatePin,
  updatePassword,
  updatePhone,
  updateSmsNotification,
} from './update'
import { getLimits } from './getLimits.js'
import { setLimits } from './setLimits.js'
import { getDeliveryInfo } from './delivery'
import { create, getPriceInfo } from './order'
import { getOobRequests } from './getOobRequests'
import { respondOob } from './respondOob'

export default {
  getList,
  getDetails,
  getSpecificDetail,
  getLimits,
  setLimits,
  updateStatus,
  updatePin,
  updatePassword,
  updatePhone,
  updateSmsNotification,
  getDeliveryInfo,
  getPriceInfo,
  create,
  getOobRequests,
  respondOob,
}
